import { request } from "@/utilities/libs/request.ts";
import { IResponseData, ListResponseData } from "@/utilities/types/requests.ts";
import { ERequestMethods } from "@/utilities/enums/RequestMethod.ts";
import { UNITS } from "../enums/Units";
import { IUnit, IUnitDTO } from "../types/Units";

function getUnits({ queryParams }: any) {
  const filters = (queryParams?.query?.filter as Record<string, any>) || {};
  const queryFiltersParams: Record<string, any> = Object.values(filters).reduce(
    (acc: any, filter: any) => {
      return {
        ...acc,
        ...filter,
      };
    },
    {},
  );
  const query = {
    sort: queryParams?.query?.sort,
    projectId:
      queryParams?.query?.projectId ||
      queryParams?.query?.filter?.[0]?.projectId,
    floorPlanId:
      queryParams?.query?.floorPlanId! ||
      queryParams?.query?.filter?.[1]?.floorPlanId,
    ...queryParams?.pagination,
    ...queryFiltersParams,
  };
  return request<ListResponseData<IUnit>>({
    method: ERequestMethods.GET,
    url: UNITS.GET,
    params: query,
  });
}

function createUnit(data: IUnitDTO) {
  return request<IResponseData<IUnit>>({
    method: ERequestMethods.POST,
    url: UNITS.CREATE,
    data,
  });
}

function bulkCreateUnits(data: Partial<IUnit>[]) {
  return request({
    method: ERequestMethods.POST,
    url: UNITS.BULK_CREATE,
    data: { units: data },
  });
}

function updateUnit(
  id: string,
  data: Partial<IUnitDTO & { projectId: string; floorPlanId: string }>,
) {
  return request<IResponseData<IUnit>>({
    method: ERequestMethods.PATCH,
    url: UNITS.UPDATE(id),
    data,
  });
}

function removeUnit(id: string) {
  return request<IResponseData<IUnit>>({
    method: ERequestMethods.DELETE,
    url: UNITS.REMOVE(id),
  });
}

function getUnitDetail(id: string) {
  return request<IResponseData<IUnit>>({
    method: ERequestMethods.GET,
    url: UNITS.DETAIL(id),
  });
}


function bulkMarkAsSold(projectId: string, unitNames: string[]) {
  return request({
    method: ERequestMethods.POST,
    url: UNITS.BULK_MARK_AS_SOLD,
    data: { projectId, unitNames },
  });
}

function markAllAsSold(projectId: string, floorPlanId: string) {
  return request({
    method: ERequestMethods.POST,
    url: UNITS.MARK_ALL_AS_SOLD,
    data: { projectId, floorPlanId },
  });
}

const UnitsRepository = Object.freeze({
  getUnits,
  createUnit,
  bulkCreateUnits,
  updateUnit,
  removeUnit,
  getUnitDetail,
  bulkMarkAsSold,
  markAllAsSold,
});

export default UnitsRepository;
